import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api', timeout: 30000 });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('rpb_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r.data,
  err => {
    const msg = err.response?.data?.message || err.message || 'Something went wrong';
    if (err.response?.status === 401 && !err.config.url.includes('/auth/')) {
      localStorage.removeItem('rpb_token');
      window.location.href = '/login';
    }
    return Promise.reject(new Error(msg));
  }
);

export const authAPI = {
  register:        d => api.post('/auth/register', d),
  login:           d => api.post('/auth/login', d),
  getMe:           () => api.get('/auth/me'),
  logout:          () => api.post('/auth/logout'),
  updateProfile:   d => api.put('/auth/profile', d),
  updatePassword:  d => api.put('/auth/password', d),
  forgotPassword:  email => api.post('/auth/forgot-password', { email }),
  resetPassword:   (token, password) => api.put(`/auth/reset-password/${token}`, { password }),
  addAddress:      d => api.post('/auth/address', d),
  toggleWishlist:  id => api.put(`/auth/wishlist/${id}`),
};

export const productAPI = {
  getAll:      p => api.get('/products', { params: p }),
  getBySlug:   slug => api.get(`/products/slug/${slug}`),
  getById:     id => api.get(`/products/${id}`),
  create:      d => api.post('/products', d),
  update:      (id, d) => api.put(`/products/${id}`, d),
  delete:      id => api.delete(`/products/${id}`),
  addReview:   (id, d) => api.post(`/products/${id}/review`, d),
  getInventory: () => api.get('/products/inventory'),
  uploadImage:  formData => api.post('/upload/image', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  uploadImages: formData => api.post('/upload/images', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

export const orderAPI = {
  create:         d => api.post('/orders', d),
  verifyPayment:  d => api.post('/orders/verify-payment', d),
  validateCoupon: d => api.post('/orders/validate-coupon', d),
  getMyOrders:    () => api.get('/orders/my'),
  getOrder:       id => api.get(`/orders/${id}`),
  trackOrder:     id => api.get('/orders/track', { params: { orderId: id } }),
  getAll:         p => api.get('/orders/all', { params: p }),
  getAnalytics:   () => api.get('/orders/analytics'),
  updateStatus:   (id, d) => api.put(`/orders/${id}/status`, d),
};

export const appointmentAPI = {
  book:            d => api.post('/appointments', d),
  verifyPayment:   d => api.post('/appointments/verify-payment', d),
  getMyAppointments: () => api.get('/appointments/my'),
  getAll:          p => api.get('/appointments/all', { params: p }),
  updateStatus:    (id, d) => api.put(`/appointments/${id}/status`, d),
};

export const astrologyAPI = {
  getAllRashifal: () => api.get('/astrology/rashifal'),
  getRashifal:   rashi => api.get(`/astrology/rashifal/${rashi}`),
  getPanchang:   () => api.get('/astrology/panchang'),
};

export const couponAPI = {
  getAll:  () => api.get('/coupons'),
  create:  d => api.post('/coupons', d),
  update:  (id, d) => api.put(`/coupons/${id}`, d),
  delete:  id => api.delete(`/coupons/${id}`),
};

export const adminAPI = {
  getUsers: p => api.get('/admin/users', { params: p }),
};

export default api;
